module.exports = __webpack_public_path__ + "static/scale-model-of-mississippi-river-museum-in-memphis-tennessee-9715026c8bdfb6bf68bcc45b23f7983a.png";